import React from "react";
import { Formidable } from "./../../";
import styles from "./Select.module.scss";
import classNames from "classnames";
import { Error, LabelChildren } from "../Forms/FormFieldInputNew";
import _ from "lodash";
import Select from "./Select";
import { ErrorTypeEnum } from "../Forms/formUtil";

const FormFieldSelect = React.memo(React.forwardRef(({
                                                        isOptional, label, labelChildren, useLabelMargin, bottomMargin = true,
                                                        type, name, onChange, value, errorMessage, showError, errorType = ErrorTypeEnum.ERROR, isDisabled, disabled,
                                                        inputChildren, inputButtons, inputChildrenClassName, inputChildrenStyle,
                                                        className, style, inputStyle, labelStyle, inputClassName, labelClassName,
                                                        errorClassName, errorStyle,
                                                        pending, showSecondaryLabelInSelectedOption,
                                                        placeholder, isLoading, noOptionsMessage,
                                                        options, isClearable, menuPortalTarget, isSearchable, isMulti, isRequireAcceptOnChange, isCreatable,
                                                        ...rest
                                                    }, ref) => {
    const hasError = showError && errorMessage && errorType === ErrorTypeEnum.ERROR;
    if (_.isUndefined(isDisabled) && disabled === true) {
        isDisabled = true;
    }

    return <div className={classNames(styles.base, { [styles['margin-bottom']]: bottomMargin }, className)} style={style} ref={ref}>
        <LabelChildren disabled={isDisabled} isOptional={isOptional} labelChildren={labelChildren}/>
        <label className={classNames({ [styles["disabled"]]: disabled })}>
            {label && <span className={classNames(labelClassName, styles["label"])} style={labelStyle}>{label}</span>}
            {useLabelMargin && <span className={classNames(labelClassName, styles["label"])} style={labelStyle}>&nbsp;</span>}
            <Select
                placeholder={placeholder}
                value={value}
                isLoading={isLoading}
                showSecondaryLabelInSelectedOption={showSecondaryLabelInSelectedOption}
                isDisabled={isDisabled}
                options={options}
                isClearable={!isRequireAcceptOnChange && isClearable}
                onChange={onChange}
                name={name}
                hasError={hasError}
                menuPortalTarget={menuPortalTarget}
                isSearchable={isSearchable || isCreatable}
                isMulti={isMulti}
                noOptionsMessage={noOptionsMessage}
                isRequireAcceptOnChange={isRequireAcceptOnChange}
                isCreatable={isCreatable}
            />
        </label>
        <Error
            showError={showError}
            errorClassName={errorClassName}
            errorStyle={errorStyle}
            errorType={errorType}
            errorMessage={errorMessage}
        />
    </div>
}))

export default React.forwardRef((props, ref) => {
    return <Formidable {...props} ref={ref} Component={FormFieldSelect}/>
});
